/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Select1Inputs */

const en_entity_select1 = /** @type {(inputs: Entity_Select1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const de_entity_select1 = /** @type {(inputs: Entity_Select1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswählen`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {Entity_Select1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_select1 = /** @type {((inputs?: Entity_Select1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Select1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_select1(inputs)
	return de_entity_select1(inputs)
});
export { entity_select1 as "entity_Select" }